import React, { useState } from 'react';
import {
  Box,
  Tab,
  Paper
} from '@mui/material';
import ConsoleTabs from '../common/ConsoleTabs';
import ServiceNowAdmin from './ServiceNowAdmin';
import TSIAdminConfiguration from './TSIAdminConfiguration';
import SyntheticTestsAdmin from './SyntheticTestsAdmin';
import VitalSignsConfigAdmin from './VitalSignsConfigAdmin';

/**
 * OpsCenterAdmin component - Container for Ops Center administration
 * Contains tabs for Major Incidents, TSI tickets, Synthetic Tests and the Vital Signs configuration
 * @returns {JSX.Element} OpsCenterAdmin component
 */
const OpsCenterAdmin = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <Paper sx={{ mb: 2 }}>
        <ConsoleTabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Major Incidents" />
          <Tab label="TSI Tickets Configuration" />
          <Tab label="Synthetic Tests" />
          <Tab label="Vital Signs Config" />
        </ConsoleTabs>
      </Paper>

      {tabValue === 0 && (
        <ServiceNowAdmin />
      )}

      {tabValue === 1 && (
        <TSIAdminConfiguration />
      )}

      {tabValue === 2 && (
        <SyntheticTestsAdmin />
      )}

      {tabValue === 3 && (
        <VitalSignsConfigAdmin />
      )}
    </Box>
  );
};

export default OpsCenterAdmin;
